import React, { Component } from 'react'
import { Row, Col, Alert } from 'antd'

class PublicFormSubmitted extends Component {

    render() {
        return (
            <Row>
                <Col span={24}>
                    <div>
                        <h1>
                            Resultado da Submissão
                        </h1>
                        <Alert style={{display: this.props.complete && !this.props.error ? 'block' : 'none' }}
                            message="Sucesso!"
                            description="A ocorrência foi registada com sucesso. Obrigado."
                            type="success"
                            showIcon
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default PublicFormSubmitted;



// WEBPACK FOOTER //
// ./src/components/PublicFormSubmitted.js